/* Noir Premium — theme.js */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(match[0], value);
  }

  function lockScroll(on) { document.body.classList.toggle('is-locked', on); }

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Barra de anuncios ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.dataset.speed, 10) || 4000;
    setInterval(function () {
      var current = items[i];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () { current.classList.remove('is-leaving'); }, 500);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  }

  /* ---------- Menú y búsqueda ---------- */
  function initHeader() {
    var menu = $('[data-menu-drawer]');
    $$('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { openDrawer(menu); b.setAttribute('aria-expanded', 'true'); });
    });
    $$('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        closeDrawer(menu);
        $$('[data-menu-open]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      });
    });

    var searchBar = $('[data-search-bar]');
    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!searchBar) return;
        searchBar.hidden = !searchBar.hidden;
        if (!searchBar.hidden) $('input[type="search"]', searchBar).focus();
      });
    });
    $$('[data-search-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (searchBar) searchBar.hidden = true; });
    });
  }

  /* ---------- Carrito ---------- */
  var cartDrawerEl = function () { return $('[data-cart-drawer]'); };

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    var current = cartDrawerEl();
    if (!fresh || !current) return;
    var wasOpen = current.classList.contains('is-open');
    current.innerHTML = fresh.innerHTML;
    current.dataset.count = fresh.dataset.count;
    if (wasOpen) current.classList.add('is-open');
    updateCount(parseInt(fresh.dataset.count, 10) || 0);
  }

  function useDrawer() { return theme.cartType === 'drawer' && cartDrawerEl(); }

  function initCart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && useDrawer()) {
        e.preventDefault();
        openDrawer(cartDrawerEl());
        return;
      }
      if (e.target.closest('[data-cart-close]')) {
        closeDrawer(cartDrawerEl());
        return;
      }
      var change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        var drawer = cartDrawerEl();
        if (drawer) drawer.classList.add('is-loading');
        fetch(theme.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: parseInt(change.dataset.lineChange, 10),
            quantity: parseInt(change.dataset.qty, 10),
            sections: 'cart-drawer'
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.sections) renderDrawer(data.sections['cart-drawer']);
          })
          .finally(function () {
            var d = cartDrawerEl();
            if (d) d.classList.remove('is-loading');
          });
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form || !useDrawer()) return;
      e.preventDefault();

      var button = form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-form-error]');
      if (button) button.setAttribute('aria-busy', 'true');
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (errorEl) { errorEl.textContent = data.description || data.message; errorEl.hidden = false; }
            else alert(data.description || data.message);
            return;
          }
          if (data.sections) renderDrawer(data.sections['cart-drawer']);
          openDrawer(cartDrawerEl());
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (button) button.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Cantidad ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = e.target.closest('[data-qty-input]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min, 10) || 0;
      var val = parseInt(input.value, 10) || 0;
      input.value = Math.max(min, val + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Envío automático (orden, filtros, carrito) ---------- */
  function initAutoSubmit() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-auto-submit]')) return;
      var form = e.target.form;
      if (!form) return;
      clearTimeout(form._t);
      form._t = setTimeout(function () { form.submit(); }, e.target.type === 'number' ? 500 : 0);
    });

    var filters = $('[data-filters-drawer]');
    $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(filters); }); });
    $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(filters); }); });
  }

  /* ---------- Producto ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addText = $('[data-add-text]', section);
    var addLabel = (addBtn && addBtn.dataset.label) || 'Agregar al carrito';
    var gallery = $('[data-gallery]', section);
    var main = gallery && $('[data-gallery-main]', gallery);
    var slides = main ? $$('.gallery__slide', main) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var dots = gallery ? $$('.gallery__dot', gallery) : [];
    var sticky = $('[data-sticky-atc]', section);
    var desktop = window.matchMedia('(min-width: 990px)');

    function setActive(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function showMedia(mediaId) {
      var index = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (index < 0) return;
      setActive(index);
      if (!desktop.matches && main) main.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    if (main && slides.length > 1) {
      var ticking = false;
      main.addEventListener('scroll', function () {
        if (desktop.matches || ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var index = Math.round(main.scrollLeft / main.clientWidth);
          setActive(index);
          ticking = false;
        });
      }, { passive: true });
    }

    function selectedOptions() {
      var radios = $$('input[type="radio"][data-option-index]:checked', section);
      var opts = [];
      radios.forEach(function (r) { opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
      return opts;
    }

    function updatePrice(variant) {
      $$('[data-price]', section).forEach(function (wrap) {
        var current = $('[data-price-current]', wrap);
        var compare = $('[data-price-compare]', wrap);
        var badge = $('[data-price-badge]', wrap);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (current) current.textContent = formatMoney(variant.price);
        if (compare) { compare.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !onSale; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }
        wrap.classList.toggle('price--sale', !!onSale);
      });
      var sp = $('[data-sticky-price]', section);
      if (sp) sp.textContent = formatMoney(variant.price);
    }

    function onChange() {
      var opts = selectedOptions();
      opts.forEach(function (val, i) {
        var label = $('[data-option-label="' + i + '"]', section);
        if (label) label.textContent = val;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var stickyBtn = $('[data-sticky-add]', section);

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'No disponible';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? addLabel : 'Agotado';
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'Agregar' : 'Agotado'; }
      updatePrice(variant);
      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('input[type="radio"][data-option-index]', section).forEach(function (r) {
      r.addEventListener('change', onChange);
    });

    if (sticky && addBtn) {
      var stickyBtn = $('[data-sticky-add]', section);
      if (stickyBtn) stickyBtn.addEventListener('click', function () { addBtn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed);
          sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        }).observe(addBtn);
      }
    }
  }

  /* ---------- Recomendaciones ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var load = function () {
        fetch(el.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-recommendations]');
            if (fresh && fresh.innerHTML.trim()) {
              el.innerHTML = fresh.innerHTML;
              initReveal(el);
            }
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else { load(); }
    });
  }

  /* ---------- Animación al hacer scroll ---------- */
  function initReveal(ctx) {
    var items = $$('.reveal:not(.is-visible)', ctx);
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(siblings, 6) * 70 + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- Inicio ---------- */
  function init() {
    initAnnouncement();
    initHeader();
    initCart();
    initQuantity();
    initAutoSubmit();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de temas: re-iniciar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('[data-product-section]', e.target).forEach(initProduct);
    if ($('[data-announcement]', e.target)) initAnnouncement();
  });
})();
